import { Link } from 'react-router-dom';

const MobileToggleSummary = (props) => {
  const { onToggleMobile, showAdjustShipment = false, clubMembership } = props;
  const toggleMobileSummary = (e) => {
    e.preventDefault();
    onToggleMobile();
  };
  if (showAdjustShipment && clubMembership) {
    return (
      <div className="c7-checkout-template__toggle">
        <div>
          <Link to={`/profile/club-membership/${clubMembership.id}/shipment`}>
            <span>Adjust Your Shipment</span>
          </Link>
        </div>
      </div>
    );
  }
  return (
    <div className="c7-checkout-template__toggle">
      <div>
        <a onClick={toggleMobileSummary}>
          <span>Show club summary</span>
        </a>
      </div>
    </div>
  );
};
export default MobileToggleSummary;
